import React, { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { useHeaderStore } from '@/store/useHeadersStylesStore.ts';
import LogoPrimaryShape from '@/components/common/svg/shapes/LogoPrimaryShape.tsx';
import { routes } from '@/navigation/routes.tsx';
import UIConfig from '@/UIConfig.ts';

export const HeaderLayout: React.FC = () => {
  const { backgroundColor, logoColor, setHeaderColors, isLogoVisible } =
    useHeaderStore();
  const location = useLocation();

  useEffect(() => {
    const chatMatch = matchPath(
      {
        path: routes.chat
      },
      location.pathname
    );

    if (
      location.pathname === routes.search ||
      location.pathname === routes.messenger
    ) {
      setHeaderColors({
        backgroundColor: UIConfig.Colors.BackgroundDark,
        logoColor: UIConfig.Colors.BackgroundWhite
      });
    } else if (location.pathname === routes.registrationWelcomePage) {
      setHeaderColors({
        backgroundColor: UIConfig.Colors.BackgroundDark,
        logoColor: UIConfig.Colors.BackgroundWhite,
        isLogoVisible: false
      });
    } else if (location.pathname === routes.profile) {
      setHeaderColors({
        backgroundColor: UIConfig.Colors.BackgroundWhite,
        logoColor: UIConfig.Colors.BackgroundDark
      });
    } else if (chatMatch) {
      setHeaderColors({
        backgroundColor: UIConfig.Colors.BackgroundWhite,
        logoColor: UIConfig.Colors.BackgroundDark
      });
    } else {
      setHeaderColors({
        backgroundColor: UIConfig.Colors.BackgroundWhite,
        logoColor: UIConfig.Colors.BackgroundDark
      });
    }
  }, [location.pathname]);

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100px',
          backgroundColor,
          zIndex: 100
        }}
      />

      <div
        style={{
          position: 'fixed',
          top: '115px',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 101,
          pointerEvents: 'none'
        }}
      >
        {isLogoVisible && (
          <LogoPrimaryShape
            width={150}
            height={200}
            fillColor={logoColor}
            animated={true}
          />
        )}
      </div>
    </>
  );
};

export default HeaderLayout;
